<div>
  <wilson-transfer-preview
    [previousShift]="previousShift"
    [nextShift]="nextShift"
    [selectedTransferType]="selectedTransferType"
    [selectedDateTime]="selectedDateTime"
    [selectedDuration]="validateDurationSignal()"
  ></wilson-transfer-preview>
  <p class="mb-1">
    {{ 'page.shift_timeline.add_transfer_question' | translate }}
  </p>
  <nz-radio-group
    [(ngModel)]="selectedTransferType"
    (ngModelChange)="onTransferTypeChange()"
  >
    <label
      nz-radio
      [nzValue]="TransferType.Previous"
      [nzDisabled]="!isPreviousShiftAvailable || !isPreviousShiftEditable"
      nz-tooltip
      [nzTooltipTitle]="
        !isPreviousShiftEditable
          ? ('page.shift_timeline.add_transfer.shift_not_editable' | translate)
          : ''
      "
    >
      {{ 'page.shift_timeline.add_transfer_to_previous_shift' | translate }}
    </label>
    <label
      nz-radio
      [nzValue]="TransferType.Next"
      [nzDisabled]="!isNextShiftAvailable || !isNextShiftEditable"
      nz-tooltip
      [nzTooltipTitle]="
        !isNextShiftEditable
          ? ('page.shift_timeline.add_transfer.shift_not_editable' | translate)
          : ''
      "
    >
      {{ 'page.shift_timeline.add_transfer_to_next_shift' | translate }}
    </label>
    <label nz-radio [nzValue]="TransferType.New">
      {{ 'page.shift_timeline.add_transfer_shift' | translate }}
    </label>
  </nz-radio-group>

  <nz-divider class="my-3"></nz-divider>

  <div class="mb-3 w-100 d-block">
    <nz-segmented
      [ngModel]="selectedTransferOption"
      (nzValueChange)="updateTransferOption($event)"
      [nzOptions]="transferOptions"
      [nzBlock]="true"
    ></nz-segmented>
  </div>

  <label class="form-text"> {{ 'page.shifts.activity' | translate }}* </label>
  <nz-select
    [nzPlaceHolder]="'---'"
    [nzMaxTagCount]="1"
    nzShowSearch
    nzAllowClear
    [nzShowArrow]="true"
    [(ngModel)]="selectedActivityType"
  >
    @for (category of activityCategoriesSignal(); track category) {
      <nz-option
        [nzValue]="category.id"
        [nzLabel]="category | translateActivityCategory"
      >
      </nz-option>
    }
  </nz-select>
  <div class="mt-1 activity-tags-container">
    @for (category of quickAccessCategories(); track category.id) {
      <nz-tag
        class="cursor-pointer"
        (click)="setSelectedActivityType(category.id)"
      >
        {{ category | translateActivityCategory }}
      </nz-tag>
    }
  </div>
  @if (selectedTransferOption === TransferOption.Duration) {
    <label class="form-text">
      {{ 'page.shift_timeline.duration_in_minutes' | translate }}*
    </label>
    <nz-input-group
      class="input-increment-decrement-icons"
      [nzAddOnBefore]="minusDuration"
      [nzAddOnAfter]="addDuration"
    >
      <nz-input-number
        class="w-100 rounded-0"
        [ngModel]="validateDurationSignal()"
        [nzMin]="0"
        [nzMax]="maxDurationSignal()"
        [nzPlaceHolder]="'page.shift_timeline.duration_in_minutes' | translate"
        (input)="validateDuration($event)"
      ></nz-input-number>
    </nz-input-group>

    <ng-template #addDuration>
      <div
        class="action-icon cursor-pointer"
        (click)="
          setDuration(validateDurationSignal() + INCREMENT_DECREMENT_MINUTES)
        "
      >
        <fa-icon [icon]="faPlus"></fa-icon>
      </div>
    </ng-template>
    <ng-template #minusDuration>
      <div
        class="action-icon cursor-pointer"
        (click)="
          setDuration(validateDurationSignal() - INCREMENT_DECREMENT_MINUTES)
        "
      >
        <fa-icon [icon]="faMinus"></fa-icon>
      </div>
    </ng-template>

    <div class="mt-1">
      @if (maxDurationSignal() > 60) {
        <nz-tag class="cursor-pointer" (click)="setDuration(60)"> 60 </nz-tag>
      }
      @if (maxDurationSignal() > 120) {
        <nz-tag class="cursor-pointer" (click)="setDuration(120)"> 120 </nz-tag>
      }
      @if (maxDurationSignal() > 240) {
        <nz-tag class="cursor-pointer" (click)="setDuration(240)"> 240 </nz-tag>
      }
      <nz-tag class="cursor-pointer" (click)="setDuration(maxDurationSignal())">
        {{ maxDurationSignal() }}
      </nz-tag>
    </div>

    @if (selectedTransferType === TransferType.New) {
      <label class="form-text"> {{ 'page.shifts.start' | translate }}* </label>
      <nz-space-compact class="d-flex w-100">
        <nz-date-picker
          wilsonUseLocalizedDateFormat
          class="w-100 rounded-0"
          [nzShowTime]="true"
          [nzAllowClear]="false"
          [nzDisabledDate]="
            shiftTransferTimePickerHelperService.disabledStartDate
          "
          [nzDisabledTime]="
            shiftTransferTimePickerHelperService.disabledStartTime
          "
          [(ngModel)]="selectedDateTime"
          (ngModelChange)="onStartDateChange()"
        ></nz-date-picker>
      </nz-space-compact>
    }
  } @else {
    <wilson-transfer-by-time
      [previousShiftEndDateTime]="previousShift.endDateTime"
      [nextShiftStartDateTime]="nextShift.startDateTime"
      [selectedTransferType]="selectedTransferType"
      (durationChange)="selectedDurationSignal.set($event)"
      (selectedDateTimeChange)="changeSelectedDateTime($event)"
    ></wilson-transfer-by-time>
  }
</div>
